/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-formatting-brightness-contrast': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M9.375 1.25h1.25v1.875h-1.25V1.25zm7.5 8.125h1.875v1.25h-1.875v-1.25zm-7.5 7.5h1.25v1.875h-1.25v-1.875zm-8.125-7.5h1.875v1.25H1.25v-1.25zm2.156-5.073l.884-.883 1.326 1.325-.885.884-1.325-1.326zm10.969.436L15.7 3.412l.884.884-1.326 1.326-.883-.884zm.001 10.522l.884-.884 1.326 1.327-.883.883-1.327-1.326zm-10.957.446l1.325-1.331.881.887L4.3 16.587l-.881-.88zM10 5a5 5 0 100 10 5 5 0 000-10zm0 8.75a3.75 3.75 0 010-7.5v7.5z"/>'
  }
})
